<template>
  <div class="row">
    <div class="contents_area invoice">
      <div class="header_container">
        <h3>
          Invoice
        </h3>
        <div>
          <img src="/images/logo/logo-hrobotics-black-small.png" alt=""/>
        </div>
      </div>
      <div class="txt_body_1 text_left">
        We received payment for your rebless Clinic subscription - thank you! <br>
        You’re currently subscribed to the
        <span class="txt_subtitle_1">{{ computedProductTitle }}</span> for
        <span class="txt_subtitle_1">{{ computedAmount }} {{ computedProductAmountUnit }}</span>
        per {{ computedProductIntervalUnit }}. <br>
        Now you can use all the features of rebless Clinic.
      </div>
      <LeftHeaderTable
        :items="computedItems"
        class="mt40 mb60"
      />
      <div class="text_left">
        <a @click="goToPage('/')"
           class="regular-fill-button-blue70"
        >
          Let's go rebless clinic!
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import LeftHeaderTable from "../../../Table/leftHeaderTable";
export default {
  components: {LeftHeaderTable},
  props: {
    resultProps: {}
  },
  computed: {
    computedItems() {
      const items = [];
      const billingDate = this.moment(this.resultProps.data.billingDate).locale(this.$t('country')).format('ll');
      const expirationDate = this.moment(this.resultProps.data.expirationDate).locale(this.$t('country')).format('ll');

      items.push({title: 'Receiver', content: this.resultProps.data.email || '-'});
      items.push({title: 'Payment date', content: billingDate});
      items.push({title: 'Charged to', content: `${this.resultProps.data.cardType} ${this.$t('my.payment.details.card')}`});
      items.push({title: 'For service through', content: expirationDate});
      items.push({
        title: 'Description',
        content: `${this.resultProps.data.baseProductInfo?.defaultProductTitle}(${this.resultProps.data.baseProductInfo?.defaultProductSubTitle})`
      });
      items.push({
        title: 'Price',
        content: `${this.resultProps.data.amount} ${this.resultProps.data.baseProductInfo?.productAmountUnit}`,
        type: 'right'
      });
      items.push({
        title: 'Total Charged',
        content: `${this.resultProps.data.amount} ${this.resultProps.data.baseProductInfo?.productAmountUnit}`,
        type: 'right'
      });

      return items
    },
    computedProductTitle() {
      return this.resultProps.data.baseProductInfo?.defaultProductTitle || '-'
    },
    computedAmount() {
      return this.resultProps.data.amount || '-'
    },
    computedProductAmountUnit() {
      return this.resultProps.data.baseProductInfo?.productAmountUnit || '-'
    },
    computedProductIntervalUnit() {
      return this.resultProps.data.baseProductInfo?.productIntervalUnit || '-'
    }
  },
  methods: {
    goToPage(path) {
      this.$router.push(path);
    }
  }
}
</script>